import styled from '@emotion/styled';
import Box from '@mui/material/Box';

export const StyledFormBox = styled(Box)`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px 20px;
  border: 2px solid #fff;
  border-radius: 16px;
  background-color: #302f2f;
`;
